import { useEffect } from 'react';

export const useClickOutside = (
  refs: { ref: React.RefObject<HTMLElement>; handler: () => void }[],
  isOpen: boolean
) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      refs.forEach(({ ref, handler }) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setTimeout(handler, 0);
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs, isOpen]);
};
